<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo.png" alt="logo图">
    </div>
    <p class="title">
      {{companyName}}
    </p>
    <p class="address_tel_fax">
      <span>地址：{{ address }}</span>
    </p>
    <p class="email_wx">
      <span>邮箱：{{ comMail }}</span>
      <span>Tel：{{ comTel }}</span>
    </p>
    <p class="beian">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010302001799" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="@/assets/img/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">{{ wangAn }}</p>
      </a>
      <a href="https://beian.miit.gov.cn" target="_blank" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">{{ icpInfo }}</p></a> 
    </p>
    <p class="copy"> Copyright &copy; 2024 - {{ new Date().getFullYear() }} {{ companyName }}</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      companyName:"合肥智己网络科技有限公司",
      address:"安徽省合肥市经济技术开发区繁华大道10969号凤凰国际B座1702室-138",
      comTel:"19356310391",
      comMail:"zhiji_service@163.com",
      wangAn:"皖公网安备34019102001231号",
      icpInfo:"皖ICP备2024035239号-1"
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #24292e;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 60px;
  margin: 20px auto 20px;
}
.logo>img {
  height:65px;
  width:95px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.beian {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue